export default __webpack_public_path__ + "static/media/choose4.11dfca02.png";